import { apiClient } from "../api/apiclient"

export const postSocialReservation = (SocialReservation, token) =>
    apiClient.post("/social-reservation", SocialReservation, {
        headers: { Authorization: `Bearer ${token}` },
    });

export const geteSocialReservation = (token) =>
    apiClient.get("/reservations", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const editSocialReservation = (id, updatedReservation, token) =>
    apiClient.put(`/social-reservation/${id}`, updatedReservation, {
        headers: { Authorization: `Bearer ${token}` },
    });